import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakeGetResponder } from '../test-utils';
import { createAdminApi } from './index';
export var createAdminApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAdminApi('', fakeHttp);
    var testKit = {
        whenAppVersion: function () { return createFakeGetResponder(fakeHttp, '/admin/app/version'); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map